const $ = require('jquery');
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

export class NotificationService {

  constructor() {

  }

  info(message) {
    this.showMessage(message, 'info');
  }

  warning(message) {
    this.showMessage(message, 'warning');
  }

  success(message) {
    this.showMessage(message, 'success');
  }

  // An alias of 'error'
  danger(message) {
    this.error(message);
  }

  error(message) {
    this.showMessage(message, 'error');
  }

  showMessage(message, type = 'error') {
    switch (type) {
      case 'info':
        NotificationManager.info(message);
        break;
      case 'success':
        NotificationManager.success(message, 'Success!');
        break;
      case 'warning':
        NotificationManager.warning(message, 'Warning');
        break;
      case 'error':
        NotificationManager.error(message, 'Error');
        break;
    }
  }
}


// WEBPACK FOOTER //
// ./services/notification.service.js